import * as React from 'react'
import { KreoLogo } from '../../icons'
import { ProductFrame } from '../product-frame'
import Scrollbar from '../scrollbars'
import { Switcher } from '../switcher'
import { Text, H5 } from '../texts'
import { VideoPopUp } from '../video-pop-up'
import { Styled } from './styled'


export const ProductsPage = (props) => {
  const { products, defaultImage, nightVersion, switchTheme, RouterLink } = props;
  const [backGroundImage, setBackGroundImage] = React.useState(null)
  const [videoId, setVideoId] = React.useState(null)
  return (
    <Scrollbar>
      <Styled.Container url={backGroundImage || defaultImage}>
        <Styled.Header>
          <Styled.KreoLogoContainer>
            <KreoLogo />
            <H5 color={'white'}>KREO</H5>
          </Styled.KreoLogoContainer>
          {switchTheme && <Styled.SwitcherContainer>
            <Switcher
              // eslint-disable-next-line react/jsx-no-bind
              onChange={() => switchTheme(nightVersion)}
              name="Night mode"
              checked={nightVersion === false}
              themeSwitcher={true}
            />
          </Styled.SwitcherContainer>}
        </Styled.Header>
        <Styled.Content>
          <Styled.TextContainer>
            <Text fontSize={60} color={'white'}>Our products</Text>
            <Text fontSize={12} color={'white'}>Select the product you want to use:</Text>
          </Styled.TextContainer>
          <Styled.Frames products={products}>
            {products.map((el) => (
              <ProductFrame
                name={el.name}
                id={el.id}
                Logo={el.Logo}
                url={el.url}
                color={el.color}
                // eslint-disable-next-line react/jsx-no-bind
                watchDemoClick={el.videoId ? () => setVideoId(el.videoId) : null}
                // eslint-disable-next-line react/jsx-no-bind
                onMouseEnter={() => setBackGroundImage(el.image)}
                // eslint-disable-next-line react/jsx-no-bind
                onMouseLeave={() => setBackGroundImage(null)}
                additionalInfo={el.additionalInfo}
                descriptionText={el.descriptionText}
                key={el.id}
                RouterLink={RouterLink}
              />
            ))}
          </Styled.Frames>
        </Styled.Content>
      </Styled.Container>
      <VideoPopUp
        videoId={videoId}
        // eslint-disable-next-line react/jsx-no-bind
        close={() => setVideoId(null)}
      />
    </Scrollbar>
  )
}
